const image = "_35simp9xzt";
const contextMenu = "_35sc189ztiy";

export { contextMenu, image };
import "./printer.image.style.linaria.module.css";
//# sourceMappingURL=printer.image.style.js.map
